<template>
	<div class="video-wrap" :class="ishiden ? 'ishiden' : ''" @click="videoPause">
		<div data-vjs-player>
			<video
				ref="videoNode"
				class="video-js vjs-default-skin vjs-big-play-centered"
				playsinline
				webkit-playsinline
				x5-video-player-type="h5"
			>
				抱歉，您的浏览器不支持
			</video>
			<div v-if="videoPauseShow" class="prism-big-play-btn" @click.stop="videoPlay">
				<div class="play-wrapper" :class="{ 'yili': isyili }">
					<img class="play-icon" src="@/assets/images/banner_play.png" alt="" />
					<p>播放</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'OldVideo'
};
</script>
<script setup>
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { catchClick } from '@/utils/api';

// Props定义
const props = defineProps({
	fluid: {
		type: Boolean,
		default: true
	},
	controls: {
		type: Boolean,
		default: true
	},
	preload: {
		type: String,
		default: 'auto'
	},
	autoplay: {
		type: Boolean,
		default: false
	},
	width: {
		type: String,
		default: '100%'
	},
	height: {
		type: String,
		default: '2.11rem'
	},
	sourceSrc: {
		type: String,
		default: ''
	},
	poster: {
		type: String,
		default: ''
	},
	isyili: {
		type: Boolean,
		default: false
	}
});

// Emits定义
const emit = defineEmits(['playstatusCallback']);

// Refs
const videoNode = ref(null);

// 响应式状态
const player = ref(null);
const videoPauseShow = ref(true);
const isFullscreen = ref(false);
const ishiden = ref(true);

const vm = getCurrentInstance();
// Methods
const videoPlay = catchClick(function () {
	player.value.play();
	videoPauseShow.value = false;
	emit('playstatusCallback', true);
}, vm.proxy);

const videoPause = () => {
	player.value.pause();
	emit('playstatusCallback', false);
};

// 初始化播放器
onMounted(() => {
	let options = {
		fluid: props.fluid,
		controls: props.controls,
		//自动播放属性,muted:静音播放
		autoplay: props.autoplay,
		//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
		preload: props.preload,
		//设置视频播放器的显示宽度（以像素为单位）
		width: props.width,
		//设置视频播放器的显示高度（以像素为单位）
		height: props.height,
		poster: props.poster,
		controlBar: {
			// children: [
			//     {name: 'playToggle'}, // 播放按钮
			//     {name: 'progressControl'}, // 播放进度条
			// ]
		},
		sources: [
			{
				src: props.sourceSrc,
				type: 'video/webm'
			},
			{
				src: props.sourceSrc,
				type: 'video/mp4'
			},
			{
				src: props.sourceSrc,
				type: 'video/ogg'
			}
		]
	};
	// TODO: Review 播放是否正才,$('.vjs-big-play-button').remove(); this 指向
	player.value = videojs(videoNode.value, options, function onPlayerReady() {
		this.on('pause', () => {
			videoPauseShow.value = true;
		});
		this.on('play', () => {
			videoPauseShow.value = false;
		});
	});
	$('.vjs-big-play-button').remove();
});

onBeforeUnmount(() => {
	if (player.value) {
		player.value.dispose();
	}
});

defineExpose({
	player
});
</script>

<style lang="less" scoped>
.video-wrap {
	position: relative;
	.prism-big-play-btn {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		// margin:  -.24rem 0 0 -.24rem;
		// width: 0.48rem;
		// height: 0.48rem;
		cursor: pointer;
		color: #fff;
		line-height: 0.48rem;
		text-align: center;
		font-size: 0.32rem;
		z-index: 100;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.play-wrapper {
		padding: 0.03rem 0.08rem;
		display: flex;
		align-items: center;
		background: rgba(0, 0, 0, 0.4);
		border-radius: 0.6rem;

		&.yili {
			background: #ff6619;
		}
		.play-icon {
			width: 0.18rem;
			height: 0.18rem;
		}
		p {
			margin-left: 0.04rem;
			color: #fff;
			font-family: PingFang SC;
			font-size: 0.12rem;
			font-style: normal;
			font-weight: 400;
			line-height: 0.16rem; /* 133.333% */
		}
	}
}
.ishiden {
	/deep/.video-js .vjs-control-bar {
		display: none;
	}
	/deep/ .vjs-poster {
		background-size: cover;
	}
}
</style>
